import { Link } from 'react-router-dom';
import { Award, Calendar } from 'lucide-react';

interface Milestone {
  id: string;
  first_name: string;
  therapy_start_date: string;
  days_in_therapy: number;
  milestone: number;
  days_until_milestone: number;
}

interface ClientMilestonesProps {
  milestones: Milestone[];
}

export function ClientMilestones({ milestones }: ClientMilestonesProps) {
  if (milestones.length === 0) {
    return null;
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Upcoming Milestones</h2>
      <div className="bg-white rounded-lg border border-gray-200">
        <div className="divide-y divide-gray-100">
          {milestones.map((milestone) => (
            <Link
              key={`milestone-${milestone.id}-${milestone.milestone}`}
              to={`/app/clients/${milestone.id}`}
              className="block p-4 hover:bg-gray-50 transition-colors group"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-amber-50 group-hover:bg-amber-100 transition-colors">
                    <Award className="w-5 h-5 text-amber-600" />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm">🎯</span>
                    <p className="font-medium text-gray-900 group-hover:text-blue-600 transition-colors">
                      Milestone: {milestone.first_name}
                    </p>
                  </div>
                  <p className="text-sm text-gray-600">
                    {milestone.days_until_milestone === 0
                      ? `Reaches ${milestone.milestone}-day milestone today!`
                      : `Reaches ${milestone.milestone}-day milestone in ${milestone.days_until_milestone} day${milestone.days_until_milestone !== 1 ? 's' : ''}`}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    Day {milestone.days_in_therapy} in therapy
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
